import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronLeft, MapPin, Users } from "lucide-react";
import api from "@/lib/api";
import CandidateCard from "@/components/CandidateCard";

export default function DelegationDetail() {
  const { code } = useParams();
  const [d, setD] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => { api.get(`/delegations/${code}`).then((r) => setD(r.data)).catch(() => setNf(true)); }, [code]);

  if (nf) return <div className="section py-32 text-center"><h1 className="text-3xl text-amber-50">Delegation not found</h1><Link to="/delegations" className="mt-4 inline-block text-gold">← All delegations</Link></div>;
  if (!d) return <div className="section py-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="section py-8" data-testid="delegation-detail">
      <Link to="/delegations" className="inline-flex items-center gap-1 text-sm text-gold hover:gap-2 transition-all"><ChevronLeft className="h-4 w-4" /> All Delegations</Link>

      <div className="mt-6 glass rounded-2xl p-8 sm:p-12">
        <span className="text-7xl">{d.flag}</span>
        <h1 className="mt-4 text-4xl sm:text-6xl text-amber-50">{d.name}</h1>
        <div className="mt-4 flex flex-wrap gap-6 text-sm text-amber-100/70">
          <span className="flex items-center gap-2"><MapPin className="h-4 w-4 text-gold" /> {d.capital}, {d.region} Africa</span>
          {d.population > 0 && <span className="flex items-center gap-2"><Users className="h-4 w-4 text-gold" /> {d.population}M people</span>}
        </div>
        <p className="mt-5 max-w-2xl text-amber-100/60">{d.cultural_info}</p>
        <p className="mt-3 text-xs uppercase tracking-wider text-muted-foreground">National Director: <span className="text-gold">{d.national_director}</span></p>
      </div>

      <div className="mt-12">
        <p className="kicker mb-6">Delegation Candidate{d.candidates.length !== 1 ? "s" : ""}</p>
        {d.candidates.length === 0 ? (
          <div className="card-lux p-10 text-center">
            <p className="text-amber-100/60">This delegation's candidate will be announced soon.</p>
            <Link to="/candidates" className="btn-ghost-gold mt-5 inline-block">Explore other candidates</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {d.candidates.map((c, i) => <CandidateCard key={c.id} candidate={c} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
